/* The mockup's `.av-edit` and `.avatar-lg`: a 64px round face beside its buttons. */
.editor {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-4);
}

.face {
  display: grid;
  place-items: center;
  flex: none;
  inline-size: 64px;
  block-size: 64px;
  overflow: hidden;
  border-radius: 50%;
  background: var(--surface-sunken);
  color: var(--text-muted);
  font-size: var(--font-size-20);
  font-weight: var(--font-weight-semibold);
}

.picture {
  inline-size: 100%;
  block-size: 100%;
  object-fit: cover;
}

.actions {
  display: grid;
  gap: 6px;
}

.buttons {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
}

/* Opened by the visible button; never in the tab order or the accessibility tree twice. */
.file {
  display: none;
}
